import React from "react";

import items from "./items";

const BaseItem = props => {
  const Type = items[props.kind.replace(/\w/, c => c.toUpperCase())];

  return Type ? <Type {...props} /> : null;
};

export default BaseItem;
